import { CustomerListItemViewModel, InvoiceCustomerDetailViewModel } from "@payping/api";
import { ClearListAction, LoggedOutAction } from "./types";
import { CLEAR_LIST, LOGGED_OUT } from "./constants";

export const CUSTOMERS_LOADED = "CUSTOMERS_LOADED";
export const SET_CUSTOMER_DETAILS = "SET_CUSTOMER_DETAILS";
export const CUSTOMER_REMOVED = "CUSTOMER_REMOVED";

export interface CustomerState {
  list: CustomerListItemViewModel[];
  totalCount: number;
  paginationEnd: boolean;
  details?: InvoiceCustomerDetailViewModel;
}

export interface CustomersLoadedAction {
  type: typeof CUSTOMERS_LOADED;
  payload: { list: CustomerListItemViewModel[]; totalCount: number; append: boolean };
}

export interface SetCustomerDetailsAction {
  type: typeof SET_CUSTOMER_DETAILS;
  payload: { details: InvoiceCustomerDetailViewModel };
}

export interface CustomerRemovedAction {
  type: typeof CUSTOMER_REMOVED;
  payload: { code: string };
}

export type CustomerActionTypes =
  | CustomersLoadedAction
  | SetCustomerDetailsAction
  | CustomerRemovedAction
  | ClearListAction
  | LoggedOutAction;

const initialState: CustomerState = {
  details: undefined,
  list: [],
  paginationEnd: false,
  totalCount: 0,
};

export default function customers(state = initialState, action: CustomerActionTypes): CustomerState {
  if (action.type === CUSTOMERS_LOADED) {
    const { list, totalCount, append } = action.payload;
    const newList = append ? [...state.list, ...list] : list;
    return {
      ...state,
      list: newList,
      paginationEnd: !list.length || newList.length >= totalCount,
      totalCount,
    };
  }

  if (action.type === SET_CUSTOMER_DETAILS) {
    const { details } = action.payload;
    return {
      ...state,
      details,
    };
  }

  if (action.type === CUSTOMER_REMOVED) {
    const { code } = action.payload;
    const list = state.list.filter((item) => item.code !== code);
    const details = state.details && state.details.code === code ? initialState.details : state.details;

    return {
      ...state,
      details,
      list,
    };
  }

  if (action.type === CLEAR_LIST) {
    return {
      ...state,
      list: [],
    };
  }

  if (action.type === LOGGED_OUT) {
    return initialState;
  }
  return state;
}
